import { ApolloProvider } from '@apollo/client';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { LoadedImageProvider } from './components/LoadingIndicators/ImageLoader/LoadedImageContext';
import SentryErrorBoundary from './components/SentryErrorBoundary';
import SentryUserProvider from './components/SentryUserProvider';
import SeoManager from './components/SeoManager';
import { SocketProvider } from './contexts/socketContext';
import { client } from './graphql/client';
import './i18n/i18n';
import './index.css';
import { persistor, store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import { router } from './routes/router';
import './sentry';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

dayjs.extend(isYesterday);
dayjs.extend(isToday);
dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(localeData);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const App = () => {
  return (
    <React.StrictMode>
      <SentryErrorBoundary>
        <HelmetProvider>
          <ApolloProvider client={client}>
            <Provider store={store}>
              <SentryUserProvider>
                <PersistGate loading={null} persistor={persistor}>
                  <SocketProvider>
                    <LoadedImageProvider>
                      <SeoManager />
                      <RouterProvider router={router} />
                    </LoadedImageProvider>
                  </SocketProvider>
                </PersistGate>
              </SentryUserProvider>
            </Provider>
          </ApolloProvider>
        </HelmetProvider>
      </SentryErrorBoundary>
    </React.StrictMode>
  );
};

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
